/**
 * Enums matching backend API enums
 */

export enum EntryStatus {
  DRAFT = 'DRAFT',
  REVIEWED = 'REVIEWED',
  PUBLISHED = 'PUBLISHED',
}

export enum MessageType {
  TITLE = 'title',
  MEDIA = 'media',
  ALBUM = 'album',
  SEPARATOR = 'separator',
  NOISE = 'noise',
  REPLY_STUB = 'reply_stub',
  UNKNOWN = 'unknown',
}

export enum LibraryAliasType {
  TEXT = 'TEXT',
  HASHTAG = 'HASHTAG',
  SECTION = 'SECTION',
}

export enum LibrarySectionSource {
  MANUAL = 'MANUAL',
  FIHRIS_ASSISTED = 'FIHRIS_ASSISTED',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  REVIEWER = 'REVIEWER',
  VIEWER = 'VIEWER',
}

/**
 * The manuscript permission tier — `app_users.manuscript_role`, lowercase in
 * the DB. Since 2026-08-18 this, not `UserRole` (the ilm dashboard's own
 * column), decides what a signed-in user may do here: `admin` = full,
 * `reviewer` = review work only. Backend counterpart: `require_admin` in
 * `app/utils/auth.py`.
 */
export enum ManuscriptRole {
  ADMIN = 'admin',
  REVIEWER = 'reviewer',
}

export enum MediaRole {
  PRIMARY = 'PRIMARY',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
}

export const PAGE_SLUGS = [
  'dashboard', 'review', 'index-channel', 'timeline',
  'channels', 'libraries', 'entries', 'chat-preview', 'settings',
] as const;
export type PageSlug = typeof PAGE_SLUGS[number];
